import { gql, useMutation } from '@apollo/client';
import { CreateReminderJourneyInput, ReminderJourneys } from 'generated/event.types';
import { extractApolloErrorDetails } from 'services/graphql/extractApolloErrorDetails';
import Logger from 'services/logger';

const CREATE_REMINDER_JOURNEY = gql`
  mutation createReminderJourney($input: CreateReminderJourneyInput!) {
    createReminderJourney(input: $input) {
      _id
      name
      sfmcJourneyApiKey
      format
      timeInHour
      marketDefaults
      reminderType
      channel
      active
    }
  }
`;

type ResultType = {
  createReminderJourney: ReminderJourneys;
};

const useCreateReminderJourney = () => {
  const [createReminderJourney, { data, loading, error }] = useMutation<ResultType>(CREATE_REMINDER_JOURNEY);

  if (error) {
    const customContext = extractApolloErrorDetails(error);
    Logger.logError({
      error,
      customContext,
      transactionName: 'createReminderJourney.ts - createReminderJourney',
    });
  }

  const createJourney = async (input: CreateReminderJourneyInput) => {
    return createReminderJourney({
      variables: { input },
    });
  };

  return {
    createJourney,
    data: data?.createReminderJourney,
    loading,
    error,
  };
};

export default useCreateReminderJourney;
